import { Component, Input, Output, EventEmitter, Optional, Self, Injector, OnInit, ContentChild, TemplateRef } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { AppComponentBase } from '@shared/app-component-base';

@Component({
  selector: 'app-generic-select',
  templateUrl: './generic-select.component.html',
  styleUrls: ['./generic-select.component.scss']
})
export class GenericSelectComponent extends AppComponentBase implements ControlValueAccessor, OnInit {
  @Input() options: any[] = [];
  @Input() displayField: string = 'name';
  @Input() valueField: string = 'id';
  @Input() label: string = '';
  @Input() appearance: 'fill' | 'legacy' | 'outline' | 'standard' = 'fill';
  @Input() plain: boolean = false;
  @Input() loading: boolean = false;
  @Input() multiple: boolean = false;
  @Input() required: boolean = false;
  @Input() disabled: boolean = false;
  @Input() nullOption: boolean = false;
  @Input() nullOptionLabel: string = 'None';
  @Input() emptyMessage: string = 'NoResults';
  @Input() displayWith?: (option: any) => string;
  @Input() optionDisabled?: (option: any) => boolean;

  @Output() selectionChange = new EventEmitter<any>();
  @Output() opened = new EventEmitter<void>();

  @ContentChild('optionTemplate') optionTemplate: TemplateRef<any>;
  @ContentChild('triggerTemplate') triggerTemplate: TemplateRef<any>;

  value: any;
  
  onChange: any = () => {};
  onTouched: any = () => {};

  constructor(
    injector: Injector,
    @Optional() @Self() public ngControl: NgControl
  ) {
    super(injector);
    if (this.ngControl != null) {
      this.ngControl.valueAccessor = this;
    }
  }

  ngOnInit() {
  }

  writeValue(val: any): void {
    this.value = val;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  onSelectionChange(event: any) {
    this.value = event.value;
    this.onChange(this.value);
    this.onTouched();
    this.selectionChange.emit(this.value);
  }

  getOptionValue(option: any): any {
    return this.valueField ? option[this.valueField] : option;
  }

  getDisplayValue(option: any): string {
    if (this.displayWith) {
      return this.displayWith(option);
    }
    return option[this.displayField];
  }

  getErrorMessages(): string {
    if (this.ngControl && this.ngControl.errors) {
      if (this.ngControl.hasError('required')) {
        return this.l('ThisFieldIsRequired');
      }
      if (this.ngControl.hasError('maxlength')) {
        return this.l('ThisFieldIsToLarge');
      }
      if (this.ngControl.hasError('minlength')) {
        return this.l('ThisFieldIsToShort');
      }
      if (this.ngControl.hasError('email')) {
        return this.l('InvalidEmailAddress');
      }
      if (this.ngControl.hasError('pattern')) {
        return this.l('InvalidPattern');
      }
    }
    return '';
  }
}
